var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBcgRightLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 920,
    viewBox: "0 0 960 920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_69273_33430)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69273_33430",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 960,
    height: 920
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 920,
    fill: "#171B1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69273_33430)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_69273_33430)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 702.559,
    cy: 696.442,
    rx: 199.317,
    ry: 199.317,
    transform: "rotate(150 702.559 696.442)",
    fill: "url(#paint0_radial_69273_33430)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M686.872 1056C486.333 1056 323.372 892.476 323.372 691.513C323.372 490.549 486.429 327.001 686.872 327.001C734.625 326.874 781.93 336.245 826.048 354.571C870.166 372.897 910.221 399.815 943.895 433.767C949.089 438.973 953.209 445.153 956.02 451.956C958.831 458.758 960.278 466.049 960.28 473.413C960.281 480.776 958.835 488.067 956.026 494.871C953.217 501.674 949.099 507.856 943.907 513.063C938.715 518.271 932.551 522.402 925.767 525.221C918.984 528.039 911.712 529.491 904.369 529.492C897.026 529.493 889.754 528.044 882.969 525.227C876.184 522.41 870.019 518.281 864.826 513.075C825.361 473.521 773.906 448.241 718.549 441.209C663.193 434.177 607.076 445.792 559.021 474.229C510.967 502.665 473.7 546.309 453.081 598.299C432.462 650.289 429.66 707.676 445.115 761.437C460.571 815.198 493.407 862.284 538.462 895.292C583.516 928.299 638.233 945.355 694.01 943.779C749.786 942.203 803.459 922.084 846.588 886.585C889.717 851.086 919.857 802.221 932.269 747.672H686.872C679.43 747.826 672.033 746.49 665.114 743.741C658.194 740.992 651.891 736.886 646.574 731.664C641.257 726.442 637.033 720.208 634.149 713.328C631.266 706.447 629.78 699.059 629.78 691.596C629.78 684.133 631.266 676.745 634.149 669.865C637.033 662.985 641.257 656.751 646.574 651.529C651.891 646.306 658.194 642.2 665.114 639.452C672.033 636.703 679.43 635.366 686.872 635.52H994.46C1009.28 635.527 1023.49 641.429 1033.97 651.931C1044.45 662.434 1050.35 676.678 1050.37 691.537C1050.37 892.476 887.315 1056 686.872 1056Z",
    fill: "url(#paint1_radial_69273_33430)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1164.37 1032.81C1151.62 1050.68 1137.9 1067.82 1123.26 1084.17L1120.44 1087.33L720.091 1531.99C700.815 1556.06 669.381 1555.94 650.201 1531.99L255.107 1089.27C252.288 1086.21 249.541 1083.07 246.771 1079.93L246.484 1079.62V1079.47C233.43 1064.64 221.13 1049.15 209.628 1033.08V1033.08C137.883 933.258 99.3066 813.316 99.3717 690.27C99.3717 365.382 362.927 101.002 686.961 101.002C764.128 100.816 840.566 115.977 911.852 145.61C983.137 175.243 1047.86 218.758 1102.26 273.638C1112.46 284.223 1118.1 298.4 1117.97 313.116C1117.84 327.831 1111.96 341.907 1101.58 352.313C1091.2 362.718 1077.17 368.621 1062.49 368.749C1047.82 368.877 1033.68 363.221 1023.13 352.998C979.072 308.566 926.665 273.339 868.941 249.355C811.217 225.371 749.323 213.108 686.842 213.274C424.624 213.274 211.324 427.255 211.324 690.27C211.324 953.285 424.624 1167.19 686.866 1167.19C949.107 1167.19 1162.45 953.237 1162.45 690.27C1162.3 682.804 1163.63 675.382 1166.38 668.439C1169.12 661.496 1173.22 655.172 1178.43 649.837C1183.64 644.502 1189.86 640.264 1196.72 637.37C1203.59 634.477 1210.96 632.986 1218.41 632.986C1225.85 632.986 1233.23 634.477 1240.09 637.37C1246.96 640.264 1253.18 644.502 1258.39 649.837C1263.6 655.172 1267.69 661.496 1270.44 668.439C1273.18 675.382 1274.51 682.804 1274.36 690.27C1274.47 813.183 1236.04 933.018 1164.49 1032.81V1032.81H1164.37Z",
    fill: "url(#paint2_radial_69273_33430)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 687.955,
    cy: 689.319,
    r: 174.585,
    transform: "rotate(150 687.955 689.319)",
    stroke: "#3BD4AE",
    strokeOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 647.831,
    cy: 647.831,
    r: 647.331,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 420.831 1574.27)",
    stroke: "#3BD4AE",
    strokeOpacity: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_69273_33430",
    x: 5.01447,
    y: 36.3792,
    width: 959.986,
    height: 888.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_69273_33430"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_69273_33430",
    x: 453.209,
    y: 447.092,
    width: 498.7,
    height: 498.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_69273_33430"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_69273_33430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(702.522 696.305) rotate(85.8843) scale(166.618 166.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BD4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F6F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_69273_33430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(686.872 691.5) rotate(90) scale(364.5 363.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BD4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F6F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_69273_33430",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(686.872 825.5) rotate(90) scale(724.5 587.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BD4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F6F6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcgRightLogin);
export default __webpack_public_path__ + "static/media/bcg_right_login.b2699fed0a751c95867b3c40428337f2.svg";
export { ForwardRef as ReactComponent };